import React, { useRef, useMemo } from 'react'
import {useState, useEffect} from "react";
import axios from 'axios';
import { ApiKey, dataUrl, stylesFS, HighlightSvg, CommentSvg, AddToNotesSvg} from '../config.js'
import CommentBox from './CommentBox.js';
import Subscribe from './Subscribe';
import NoPrintPage from './NoPrint'
import Spinner from './Spinner';
import JoditEditor from "jodit-react";
import "jodit/es5/jodit.min.css";
import './ContentPage.css'
import PanZoom from 'react-image-pan-zoom-rotate';
import ContentProtect from './ContentProtect.js';
import RevisionSchedulerButtonsAndTextBox from './RevisionScheduler.js';
import ReactDOMServer from 'react-dom/server';
import AdditionalTabs from './MuiTabs.js';



var selectionmodifstate = {
  highlight: 1,
  comment: 2,
  removehighlight: 4,
  removecomment: 8,
  addtorevisionnote: 16
}


export default function ContentPage({ backToLogin, subject, tK, topic, type, saveState, TopicsList, LoadContentPage, revisions, onRevisionsUpdate, navigationParams}) {
  const [contenthtml, setContentHtml] = useState(null);
  const [nextTopic, setNextTopic] = useState(null);
  const [prevTopic, setPrevTopic] = useState(null);
  const [fromSearchPagethenscrollto, setfromSearchPagethenscrollto] = useState(null);
  const [isPartial, setisPartial] = useState(false);


  useEffect(()=>{
    if(TopicsList!==null)
      for (var i = 0; i < TopicsList.length; i++) {
        if(topic===TopicsList[i].Topic)
        {
          if(i!==0)
            setPrevTopic(TopicsList[i-1].Topic);
          if(i!==TopicsList.length-1)
            setNextTopic(TopicsList[i+1].Topic);
          break;
        }
      }
    var req = {
      email: localStorage.getItem('user'),
      method: 'GetContent',
      subject: subject,
      params: {
        TK: tK,
        Topic: topic
      }
    };
    const headers = { 
      'x-api-key': ApiKey
    };
    axios.post(dataUrl, req, { withCredentials: true, headers:headers}).then(resp => {
      const isPartial = resp.headers['x-content-partial'] === 'true';
       // You can manipulate the DOM here
       if (isPartial) {
        setisPartial(isPartial);
               // Create a DOM parser
       const parser = new DOMParser();
       const doc = parser.parseFromString(resp.data, 'text/html');
       const targetElement = doc.querySelector('[id^="CCTopicContent"]');
       const elementChildren = Array.from(targetElement.children);
       const len =  Array.from(targetElement.children).length;
       if (len >= 1) elementChildren[len - 1].classList.add('blurred-heavy');
       if (len >= 2) elementChildren[len - 2].classList.add('blurred-medium');
       if (len >= 3) elementChildren[len - 3].classList.add('blurred-light');
      
        const modifiedHtml = doc.body.innerHTML;
        setContentHtml(modifiedHtml);
       }
       else
        setContentHtml(resp.data);      
    }).catch(err => backToLogin(err));
  }, []);


  function ScrollToBasedOnNavigationParams()
  {      
    const paragraphs = document.getElementsByTagName('span');

    // Iterate over each paragraph and find the first match
    for ( let i = 0; i< paragraphs.length; i++) {
        if (paragraphs[i].textContent.toLowerCase().includes(navigationParams)) {
            let id = paragraphs[i].id;
             // Calculate position to scroll to
             setfromSearchPagethenscrollto(id);
            break;
        }
    }
  }


      useEffect(() => {
      if(fromSearchPagethenscrollto!=null)
        {
          document.getElementById(fromSearchPagethenscrollto).classList.add('SearchHighlight');
          document.getElementById(fromSearchPagethenscrollto).scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center'});
          const timer = setTimeout(() => {
            document.getElementById(fromSearchPagethenscrollto).classList.remove('SearchHighlight'); 
          }, 3000);
            return () => clearTimeout(timer);
        } 
    }, [fromSearchPagethenscrollto]);

  return (
     <div>
       {(contenthtml) &&
       <div>
        <ContentDisplay isPartial= {isPartial} contentBody={contenthtml} tK={tK} topic={topic} subject={subject} type={type} saveState={saveState} revisions={revisions} onRevisionsUpdate={onRevisionsUpdate} onFinishingLoad={() => { setTimeout(() => {ScrollToBasedOnNavigationParams();}, 700);}}/>
        <div className='NextPrevGroup'>
          {prevTopic && LoadContentPage &&  <div title="Previous Topic" className="Prevbutton" onClick={() => {LoadContentPage(subject, tK, prevTopic, type, TopicsList)}}>
                  <svg id="a" fill="currentColor" height="80px" width="80px" version="1.1" xmlns="http://www.w3.org/2000/svg"   viewBox="0 0 55.753 55.753">
                      <g>
                        <path d="M12.745,23.915c0.283-0.282,0.59-0.52,0.913-0.727L35.266,1.581c2.108-2.107,5.528-2.108,7.637,0.001
                          c2.109,2.108,2.109,5.527,0,7.637L24.294,27.828l18.705,18.706c2.109,2.108,2.109,5.526,0,7.637
                          c-1.055,1.056-2.438,1.582-3.818,1.582s-2.764-0.526-3.818-1.582L13.658,32.464c-0.323-0.207-0.632-0.445-0.913-0.727
                          c-1.078-1.078-1.598-2.498-1.572-3.911C11.147,26.413,11.667,24.994,12.745,23.915z"/>
                      </g>
                  </svg>
            </div>}
          {nextTopic && LoadContentPage && <div title="Next Topic" className="Nextbutton" onClick={() => {LoadContentPage(subject, tK, nextTopic, type, TopicsList)}}>
                    <svg fill="currentColor" height="80px" width="80px" version="1.1" id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.752 55.752">
                      <g>
                        <path d="M43.006,23.916c-0.28-0.282-0.59-0.52-0.912-0.727L20.485,1.581c-2.109-2.107-5.527-2.108-7.637,0.001
                          c-2.109,2.108-2.109,5.527,0,7.637l18.611,18.609L12.754,46.535c-2.11,2.107-2.11,5.527,0,7.637c1.055,1.053,2.436,1.58,3.817,1.58
                          s2.765-0.527,3.817-1.582l21.706-21.703c0.322-0.207,0.631-0.444,0.912-0.727c1.08-1.08,1.598-2.498,1.574-3.912
                          C44.605,26.413,44.086,24.993,43.006,23.916z"/>
                      </g>
                    </svg>
            </div>}
        </div>
        </div>}
     </div>
  )
}

function ContentDisplay({isPartial, contentBody, tK, topic, subject, type, saveState, revisions, onRevisionsUpdate, onFinishingLoad})
{
  // store all the transients and commit to database on page exit.
  // Load all highlights into this set and while closing the page commit them to DB
  // one item commit with change tracking variable.
  // So upon showing if there are certain highlights that cannot be shown they can be removed.
  //Todo :: reduce the redundancy and promote reusability.
  // Todo:: highlight should support comment.
  var highlightsToBeSavedtoDB = useRef(new Map());
  var commentsToBeSavedtoDB = useRef(new Map());
  var bHighlightsChanged = useRef(false);
  var bRevisionScheduleChanged = useRef(false);
  var bCommentsChanged = useRef(false);
  var bRevisionNotesChanged = useRef(false);
  var saveemail = useRef(localStorage.getItem('user'));

  // Set inital state of revision notes from DB call.
  const stylePath = useRef(stylesFS + (type==="PDF2HTML" ? tK.toLowerCase() + '_' + topic + "/" : "" ) + tK.toLowerCase() + '_' + topic + '.css');
  const contentMenuSection = useRef(null);
  const [revisionSchedule, setrevisionSchedule] = useState(null);
  const revisionScheduleref = useRef(null);
  revisionScheduleref.current = revisionSchedule;
  const [contentContextMenu, setContentContextMenu] = useState({visible: false, type: {highlightstate: 0, highlightreference: null, commentstate:0, commentreference: null}});
  const [openMenu, setOpenMenu] = useState(true);
  const [ContentSBTabState, setContentSBTabState] = useState(1);
  const [value, setValue] = useState('');
  const [addtoNotesText, setaddtoNotesText] = useState('');

  const RNValue = useRef('');
  RNValue.current = value;
  const [fullScreenChecked, setFullScreenChecked] = useState(false); 
  const [screenOrientation, setScreenOrientation] = useState('');
  const [screenOrientationwarning, setScreenOrientationWarning] = useState(false);
  const [screenOrientationWarningTimerId, setScreenOrientationWarningTimerId] = useState(null);

  const [imageSrc, setImageSrc] = useState("");
  const panZoomRef = useRef(null);
  const [showCommentBox, setShowCommentBox] =  useState(false);
  const [showContentProtection, setShowContentProtection] = useState(false);
  const [isSaving, setIsSaving] = useState(false); // State to track if saving
    const editorRef = useRef(null);

  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!contentBody) return;

    // create temporary container to find images
    const container = document.createElement("div");
    container.innerHTML = contentBody;

    const imgs = Array.from(container.querySelectorAll("img"));
    if (imgs.length === 0) {
      setIsReady(true);
      return;
    }

    let loaded = 0;
    const done = () => {
      loaded++;
      if (loaded === imgs.length) setIsReady(true);
    };

    imgs.forEach((img) => {
      if (img.complete) {
        done();
      } else {
        img.onload = img.onerror = done;
      }
    });

    // fallback safety (e.g. broken images) → show after 3s max
    const timeout = setTimeout(() => setIsReady(true), 3000);

    return () => clearTimeout(timeout);
  }, [contentBody]);




  function commentBoxOnDeleteComment(reference)
  {

    PerformAction( selectionmodifstate.removecomment , {highlightstate: 0, highlightreference: null, commentstate:0, commentreference: reference});
    setShowCommentBox(null);
  }
  function commentBoxOnChangeComment(newcomment, ref)
  {
    bCommentsChanged.current = true;
    const commentObject = commentsToBeSavedtoDB.current.get(ref);
    commentObject.comment = newcomment;
  }
  useEffect(() => {
    if (!isSaving) {
      setIsSaving(true);
      saveToDb() // Function to save data to DB
        .then(() => setIsSaving(false));
      }
  }, [saveState]);


 
  function onCPMenuItem(scrollIndex)
    {
      document.querySelectorAll('h1[class^=CivilsCode], p span[class^=CivilsCodeHeading1Char], h2[class^=CivilsCode], p span[class^=CivilsCodeHeading2Char]')[scrollIndex].scrollIntoView(({ behavior: 'smooth' }));
    }


  function GetRevisionNotesAndShowThem()
  {
    var req = {
      email: saveemail.current,
      method: 'GetRevisionNotes',
      subject: subject,
      params: {
        TK: tK,
        Topic: topic,
      }
    };
    const headers = { 
      'x-api-key': ApiKey
    };
    axios.post(dataUrl, req, { withCredentials: true, headers:headers}).then(resp => {
      setValue(resp.data);
    }).catch(err => console.log(err));
  }
  function GetHighlightsRevisionScheduleCommentsAndShowThem()
  {
    var req = {
      email: localStorage.getItem('user'),
      method: 'GetHighlights',
      subject: subject,
      params: {
        TK: tK,
        Topic: topic,
        Type: type
      }
    };
    const headers = { 
      'x-api-key': ApiKey
    };
    // Highlight is just a string object while comment is [string, string] object
    // so in merged list we have highlight stored as [string, null]
    let highlightCommentMergedList = [];
    function highlightCommentsort(item1, item2)
    {
      const highlight1 = item1[0].split(',');
      const highlight2 = item2[0].split(',');
      for (let i = 0; i < 4; i++) {
        if(Number(highlight2[i])!==Number(highlight1[i]))
          return Number(highlight2[i]) - Number(highlight1[i]);
      }
    }
    const highlightsres = axios.post(dataUrl, req, { withCredentials: true, headers:headers}).then(resp => {
      setrevisionSchedule(resp.data.RevisionSchedule ? {NextRevisionDate: resp.data.RevisionSchedule.NextRevisionDate, PreviousOffset: resp.data.RevisionSchedule.Offset, RevisionCounter : resp.data.RevisionSchedule.RevisionCounter, PreviousDateOfRevision: resp.data.RevisionSchedule.PreviousDateOfRevision }: null);
      resp.data.result.map((item) => highlightCommentMergedList.push([item, null]));
    }).catch(err => console.log(err));
    var commentreq = {
      email: localStorage.getItem('user'),
      method: 'GetComments',
      subject: subject,
      params: {
        TK: tK,
        Topic: topic,
      }
    };
    const commentsres =  axios.post(dataUrl, commentreq, { withCredentials: true, headers:headers}).then(resp => {
        resp.data.map((item) => highlightCommentMergedList.push([item[0], item[1]]));

      }).catch(err => console.log(err));
    Promise.all([highlightsres, commentsres])
    .then(() => {
      highlightCommentMergedList.sort(highlightCommentsort);
      highlightCommentMergedList.map((item) => ShowHighlightOrComment(item[0], item[1]));
    });

  }
  function ShowHighlightOrComment(valuelocal, comment=null)
    {
      var newRangeObjectLocal = document.createRange();
      const highlight = valuelocal.split(',');
      try{
         newRangeObjectLocal.setStart(document.getElementById(Number(highlight[0])).firstChild,  Number(highlight[2]));
      newRangeObjectLocal.setEnd(document.getElementById(Number(highlight[1])).firstChild, Number(highlight[3]));
         }
      catch{
        return;
      }
      var startNode = newRangeObjectLocal.startContainer;
      var endNode = newRangeObjectLocal.endContainer;
      var startIndex = newRangeObjectLocal.startOffset;
      var endIndex = newRangeObjectLocal.endOffset;

      if(startNode.isSameNode(endNode))
        {
          var spanHighlight = document.createElement('span');
          var newRangeObjectLocal2 = document.createRange();
          spanHighlight.className = comment!=null ? "Comment showcommentpin" : 'Highlight';;
          var index = SelectionToSaveintoList(startNode, endNode, startIndex, endIndex, newRangeObjectLocal);
          spanHighlight.setAttribute(comment!=null ? "commentreference" :"highlightreference", index.toString());
          // already highlighted cannot be highlighted again since no selection can be made.
          newRangeObjectLocal.surroundContents(spanHighlight);
          newRangeObjectLocal2.setStart(spanHighlight.firstChild, 0);
          newRangeObjectLocal2.setEnd(spanHighlight.firstChild, spanHighlight.firstChild.nodeValue.length);
          if(comment!=null)
              commentsToBeSavedtoDB.current.set(index.toString() , {range: newRangeObjectLocal2, comment: comment });
          else
              highlightsToBeSavedtoDB.current.set(index.toString() , newRangeObjectLocal2);
          return;
        }

        var _iterator = document.createNodeIterator(
          newRangeObjectLocal.commonAncestorContainer,
          NodeFilter.SHOW_ALL, // pre-filter
          {
              // custom filter
              // Already selected then no reselection and overlap is treated as two objects.
              acceptNode: function (node) {
                  return newRangeObjectLocal.intersectsNode(node) && node.nodeValue!= null && node.nodeValue.trim()!=='' ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
              }
          }
      );
      var _nodes = [];
      // If there is already a highlight and we select over it then we should not allow.
      // We cannot delete the existing highlight that will take user by surprise.
      while (_iterator.nextNode()) {
          if (_nodes.length === 0 && _iterator.referenceNode !== startNode)
          {
            continue;
          }
        // Already highlighted node.
        _nodes.push(_iterator.referenceNode);
          if (_iterator.referenceNode === endNode) 
            {
              break;
            }
      }
      let newRangeObjectMultiLocal = document.createRange();
      let indexMultiLocal =  SelectionToSaveintoList(startNode, 
        endNode, 
        startIndex, 
        endIndex, newRangeObjectLocal);
      for(var i = 0; i<_nodes.length; i++)
        {
          let rangeLocal = document.createRange();
          let spanHighlightLocal = document.createElement('span');
          spanHighlightLocal.className = comment!=null ? 'Comment' : 'Highlight';
          if(i===0)
            {
              if( comment!=null )
                spanHighlightLocal.className += ' showcommentpin';
              rangeLocal.setStart(startNode, startIndex);
              rangeLocal.setEnd(startNode, startNode.nodeValue.length);
            }
          else if(i===_nodes.length-1)
            {
              rangeLocal.setStart(endNode, 0);
              rangeLocal.setEnd(endNode, endIndex);
            }
          else
            {
              if(_nodes[i].nodeType===document.TEXT_NODE)
              {
                rangeLocal.setStart(_nodes[i], 0);
                rangeLocal.setEnd(_nodes[i], _nodes[i].nodeValue.length);
              }
              else if(_nodes[i].nodeType===document.ELEMENT_NODE)
              {

                _nodes[i].parentNode.insertBefore(spanHighlightLocal, _nodes[i]);
                spanHighlightLocal.appendChild(_nodes[i]);
                for(var childMulti=spanHighlight.firstChild; childMulti!==null; childMulti=childMulti.nextSibling) {
                  newRangeObjectMultiLocal.selectNode(childMulti);
                }  

                continue;
              }
            }
            rangeLocal.surroundContents(spanHighlightLocal);
            if(i===0)
              {
                newRangeObjectMultiLocal.setStart(spanHighlightLocal.firstChild, 0);
              }
            if(i===_nodes.length-1)
              {
                newRangeObjectMultiLocal.setEnd(spanHighlightLocal.firstChild, spanHighlightLocal.firstChild.nodeValue.length);
              }
              spanHighlightLocal.setAttribute(comment!=null ? 'commentreference' : 'highlightreference', indexMultiLocal);      
            /*for(let childMulti=spanHighlightLocal.firstChild; childMulti!==null; childMulti=childMulti.nextSibling) {
              newRangeObjectMultiLocal.selectNode(childMulti);
            }*/          
       }
       if(comment!==null)
          commentsToBeSavedtoDB.current.set(indexMultiLocal.toString() , {range: newRangeObjectMultiLocal, comment: comment});
      else
          highlightsToBeSavedtoDB.current.set(indexMultiLocal.toString() , newRangeObjectMultiLocal);
       highlightsToBeSavedtoDB.current.set(indexMultiLocal.toString() , newRangeObjectMultiLocal);
       return;
      
    }
  function SaveRevisionNotesToDB()
    {
      if(bRevisionNotesChanged.current===false)
        return Promise.resolve();;
      var req = {
          email: saveemail.current,
          method: 'SaveRevisionNotes',
          subject: subject,
          params: {
            TK: tK,
            Topic: topic,
            RevisionNotes: RNValue.current
          }
        };
        const headers = { 
          'x-api-key': ApiKey
        };
        return axios.post(dataUrl, req, { withCredentials: true, headers:headers}).then(resp => {
          //var data = JSON.parse(resp.data);
          //todo:: redirect to payment page.
          bRevisionNotesChanged.current = false;
          console.log(req);
        }).catch(err => console.log(err));
      
    }
    function SaveRevisionSchedule()
    {
      if(bRevisionScheduleChanged.current===false)
        return Promise.resolve();
      let separator = '^';
      var req = {
        email: saveemail.current,
        method: 'SaveRevisionSchedule',
        subject: subject,
        params: {
          TK: tK,
          Topic: topic,
          Type: type,
          NextRevisionDate: revisionScheduleref.current.NextRevisionDate,
          Offset: revisionScheduleref.current.Offset
        }
      };
      const headers = { 
        'x-api-key': ApiKey
      };
      return axios.post(dataUrl, req, { withCredentials: true, headers:headers}).then(resp => {
        //var data = JSON.parse(resp.data);
        //todo:: redirect to payment page.
        bRevisionScheduleChanged.current = false;
        let newState = [...revisions];

        // Update the specific index with the new value
        const revisionpage = subject + separator + tK.toLowerCase() + separator + topic + separator + type;
        let foundIndex = newState.findIndex(map => map['Navigation'] === revisionpage);
        if(foundIndex===-1)
          newState.push({Navigation: revisionpage, NextRevisionDate: new Date(revisionScheduleref.current.NextRevisionDate).toISOString(), Offset: revisionScheduleref.current.Offset, PreviousDateOfRevision: new Date().toISOString(), RevisionCounter: 1});
        else{
        newState[foundIndex].NextRevisionDate = new Date(revisionScheduleref.current.NextRevisionDate).toISOString();
        newState[foundIndex].Offset = revisionScheduleref.current.Offset;
        newState[foundIndex].PreviousDateOfRevision = new Date().toISOString();
        newState[foundIndex].RevisionCounter = (parseInt(newState[foundIndex].RevisionCounter)+1).toString();
        }
        // Update the state with the new state
        onRevisionsUpdate(newState);
      }).catch(err => console.log(err));
    }
  function SaveHighlgihtsToDB()
    {
      if(bHighlightsChanged.current===false)
        return Promise.resolve();;
      //Update all the highlights in DB
      let highlightList = [];
      highlightsToBeSavedtoDB.current.forEach(function(valuelocal, key) {highlightList.push(key);});
      var req = {
        email: saveemail.current,
        method: 'SaveHighlights',
        subject: subject,
        params: {
          TK: tK,
          Topic: topic,
          Highlights: highlightList
        }
      };
      const headers = { 
        'x-api-key': ApiKey
      };
      return axios.post(dataUrl, req, { withCredentials: true, headers:headers}).then(resp => {
        //var data = JSON.parse(resp.data);
        //todo:: redirect to payment page.
        bHighlightsChanged.current = false;
        console.log(req);
      }).catch(err => console.log(err));
      }
    function SaveCommentsToDB()
    {
      if(bCommentsChanged.current===false)
        return Promise.resolve();
      //Update all the highlights in DB
      let commentList = [];
      commentsToBeSavedtoDB.current.forEach(function(valuelocal, key) {commentList.push([key, valuelocal.comment]);});
      var req = {
        email: saveemail.current,
        method: 'SaveComments',
        subject: subject,
        params: {
          TK: tK,
          Topic: topic,
          Comments: commentList
        }
      };
      const headers = { 
        'x-api-key': ApiKey
      };
      return axios.post(dataUrl, req, { withCredentials: true, headers:headers}).then(resp => {
        //var data = JSON.parse(resp.data);
        //todo:: redirect to payment page.
        bCommentsChanged.current = false;
        //console.log(req);
      }).catch(err => console.log(err));
    }
  const OnPageScroll = () => {
    if (window.getSelection) {window.getSelection().removeAllRanges();}
    else if (document.selection) {document.selection.empty();}
    setContentContextMenu({visible:false, type: {highlightstate: 0, highlightreference: null, commentstate:0, commentreference: null}});
  };
  useEffect(()=> {
    if (screenOrientationWarningTimerId) {
      clearTimeout(screenOrientationWarningTimerId); // Clear any existing timer
    }
    if(screenOrientation==="landscape")
    {
      document.documentElement.style.marginRight = "25%";
      setImageSrc(null);
      setOpenMenu(true);
      setScreenOrientationWarning(false);
    }
  else
    {
      setScreenOrientationWarning(true);
      document.documentElement.style.marginRight = "0%";
      const newTimerId = setTimeout(() => {setScreenOrientationWarning(false)}, 7000);
      setScreenOrientationWarningTimerId(newTimerId);
    }

  }, [screenOrientation] );

  const handleImgClick = event => {
    if(screenOrientation==="portrait")
      return;
    if(event.target.tagName === 'IMG') {
      setImageSrc(event.target.src);
    }
  }

  const closeImageViewer = () => {
    setImageSrc(null);
  }
  const saveToDb = async () => {
    console.log("saving data");
    await SaveRevisionNotesToDB();
    await SaveHighlgihtsToDB();
    await SaveRevisionSchedule();
    await SaveCommentsToDB();
  };

  const [activeIndexHeading, setActiveIndexHeading] = useState(null);
  const [menulist, setMenulist] = useState([]);
  const menulistliRefs = useRef([]);





  useEffect(() => {
    function handleClickOutside(e) {
    if (!editorRef.current?.container?.contains(e.target)) {
      editorRef.current?.speechRecognize?.stop(); 
    }
  }

    if(!isReady)
      return;
    //Intersection observer
    const headings = document.querySelectorAll(
      'h1[class^=CivilsCode], p span[class^=CivilsCodeHeading1Char], h2[class^=CivilsCode], p span[class^=CivilsCodeHeading2Char]'
    );
    setMenulist(Array.from(headings));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = Array.from(headings).indexOf(entry.target);
            if (index !== -1) setActiveIndexHeading(index);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -50% 0px',
        threshold: 0.1,
      }
    );

    headings.forEach((heading) => observer.observe(heading));


    const checkOrientation = () => {
      setScreenOrientation(window.innerHeight > window.innerWidth ? 'portrait' : 'landscape');
    };
    window.addEventListener('resize', checkOrientation);
    document.addEventListener("mousedown", handleClickOutside);

    
    const handleBlur = () => {
      // we can do it with state vars but want to make it with JS for better protection.
      setShowContentProtection(true);
    }
    const handleFocus = () => 
      {
        setShowContentProtection(false);

      }

    window.addEventListener('blur', handleBlur);
    window.addEventListener('focus', handleFocus);
    checkOrientation();
    var head = document.head;
    var link = document.createElement("link");

    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = stylePath.current + "?version=" + Math.floor(Math.random()*999999999).toString();
    link.async = true;

    head.appendChild(link);
    if(headings.length===0)
      setContentSBTabState(2)
    GetHighlightsRevisionScheduleCommentsAndShowThem();
    GetRevisionNotesAndShowThem();
    window.addEventListener("scroll", OnPageScroll);
    // Todo:: one call instead four calls.
    const CleanUp = (event) => {
      if(bCommentsChanged.current == false && bHighlightsChanged.current===false && bRevisionScheduleChanged.current == false && bRevisionNotesChanged.current == false)
        return;
      if(!isSaving)
      {
        event.preventDefault();
        console.log("saving data in cleanup");
        setIsSaving(true);
        saveToDb().then(() => setIsSaving(false))
        event.returnValue = '';
      }
    }
    
    window.addEventListener('beforeunload', CleanUp);
    if(type!=='PDF2HTML')
      {
        window.addEventListener('click', handleImgClick);
        window.addEventListener('touchstart', handleImgClick);
      }
      onFinishingLoad();

    // Get user information from the server and display.

    return () => { 
      document.removeEventListener("mousedown", handleClickOutside);
      headings.forEach((heading) => observer.unobserve(heading));
      window.removeEventListener('blur', handleBlur);
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('beforeunload', CleanUp);
      window.removeEventListener('resize', checkOrientation)
      if (!isSaving) {
        console.log("saving data");
        setIsSaving(true);
        saveToDb() // Function to save data to DB
          .then(() => setIsSaving(false));
       }
      head.removeChild(link); 
      document.documentElement.style.marginRight = "0%";
      window.removeEventListener("scroll", OnPageScroll);
      window.removeEventListener('blur', handleBlur);
      window.removeEventListener('focus', handleFocus);
      if(type!=='PDF2HTML')
        {
          window.removeEventListener('click', handleImgClick);
          window.removeEventListener('touchstart', handleImgClick);
        }
    }

  }, [isReady]);


  function SelectionToSaveintoList(startingNode, endingNode, startingOffset, endingOffset, rangeobject)
    {
      var start_parent = (() => {
        var parent = startingNode.parentElement;
        for(; !parent.hasAttribute("id") ; )
          {
            parent = parent.parentElement;
          }
        return parent;
      })();
      var end_parent = (() => {
        var parent = endingNode.parentElement;
        for(; !parent.hasAttribute("id") ; )
          {
            parent = parent.parentElement;
          }
        return parent;
      })();
     // https://stackoverflow.com/questions/4811822/get-a-ranges-start-and-end-offsets-relative-to-its-parent-container
      var preCaretRange = rangeobject.cloneRange();
      preCaretRange.selectNodeContents(start_parent);
      preCaretRange.setEnd(startingNode, startingOffset);
      let start = preCaretRange.toString().length;
      preCaretRange = rangeobject.cloneRange();
      preCaretRange.selectNodeContents(end_parent);
      preCaretRange.setEnd(endingNode, endingOffset);
      let end = preCaretRange.toString().length;
      var arraylist = [start_parent.getAttribute("id"), end_parent.getAttribute("id"),  start, end];
      return arraylist.join();
    }
  function DoneWithContextMenu()
  {
    setContentContextMenu(prevState => {
      return {
        visible: false,
        type:{
          commentstate:0, commentreference:null,
          highlightstate:0, highlightreference:null
        }
    }
     }
);
  }

  // Todo:: merge highlights and comments so there are no multiple calls to DB. Get in one call and put in one call.
  function PerformAction(actionId, type)
  {
    // Highlight given text
    if(actionId===selectionmodifstate.highlight || actionId===selectionmodifstate.comment)
      {
        if(window.getSelection().toString().trim()==='')
          return;
        var range =  window.getSelection().getRangeAt(0);
        var startNode = range.startContainer;
        var endNode = range.endContainer;
        var startIndex = range.startOffset;
        var endIndex = range.endOffset;
        if(startNode.isSameNode(endNode))
          {
            // index correction approach
          if(startNode.parentElement.hasAttribute('commentreference') ||  startNode.parentElement.hasAttribute('highlightreference'))
            {
            DoneWithContextMenu();
            return;
            }
          var spanHighlight = document.createElement('span');
          var newRangeObjectLocal = document.createRange();
          spanHighlight.className = actionId===selectionmodifstate.comment ? "Comment showcommentpin" : 'Highlight';
          var index = SelectionToSaveintoList(startNode, endNode, startIndex, endIndex, range);
          spanHighlight.setAttribute(actionId===selectionmodifstate.comment ? 'commentreference': 'highlightreference', index.toString());
          // already highlighted cannot be highlighted again since no selection can be made.
          range.surroundContents(spanHighlight);
          newRangeObjectLocal.setStart(spanHighlight.firstChild, 0);
          newRangeObjectLocal.setEnd(spanHighlight.firstChild, spanHighlight.firstChild.nodeValue.length);
          if(actionId===selectionmodifstate.comment)
            {
              bCommentsChanged.current = true;
              commentsToBeSavedtoDB.current.set(index.toString() , {range: newRangeObjectLocal, comment: '' });
            }
          else
            {
              bHighlightsChanged.current = true;
              highlightsToBeSavedtoDB.current.set(index.toString() , newRangeObjectLocal);
            }
          window.getSelection().removeAllRanges();
          if (actionId===selectionmodifstate.comment)
            {
              setShowCommentBox({rangeofselection: newRangeObjectLocal,  CommentBoxShow: true, reference: index.toString(), comment:''});
            }
         
          DoneWithContextMenu();
          return;
          }
        
       
        // If start and end nodes are the same
        // Each Node will be three nodes 1. textnode before start index 2. highlight span 3. text node after end index.
        // start Node.
        // Todo:: merge contiguious and have one onClick.
        var _iterator = document.createNodeIterator(
          range.commonAncestorContainer,
          NodeFilter.SHOW_ALL, // pre-filter
          {
              // custom filter
              // Already selected then no reselection and overlap is treated as two objects.
              acceptNode: function (node) {
                  return range.intersectsNode(node) && node.nodeValue!= null && node.nodeValue.trim()!=='' ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
              }
          }
      );
      var _nodes = [];
      // If there is already a highlight and we select over it then we should not allow.
      // We cannot delete the existing highlight that will take user by surprise.
      while (_iterator.nextNode()) {
          if (_nodes.length === 0 && _iterator.referenceNode !== startNode)
          {
            continue;
          }
        // Already highlighted node.
        if((((_iterator.referenceNode.nodeType===document.ELEMENT_NODE) && (_iterator.referenceNode.hasAttribute('highlightreference'))) || 
        ((_iterator.referenceNode.nodeType===document.TEXT_NODE) && (_iterator.referenceNode.parentElement.hasAttribute('highlightreference')))) || 
        (((_iterator.referenceNode.nodeType===document.ELEMENT_NODE) && (_iterator.referenceNode.hasAttribute('commentreference'))) || 
        ((_iterator.referenceNode.nodeType===document.TEXT_NODE) && (_iterator.referenceNode.parentElement.hasAttribute('commentreference')))))
            {
              if(actionId===selectionmodifstate.comment)
              {
                alert("Selection or Part of selection is already highlighted or commented");
                DoneWithContextMenu();
              }
              else
              {
              alert("Selection or Part of selection is already highlighted or commented");
                DoneWithContextMenu();
              }
              return;
            }
        _nodes.push(_iterator.referenceNode);
          if (_iterator.referenceNode === endNode) 
            {
              break;
            }
      }
 
      // Loop on each of the list of Nodes.
      let newRangeObjectMultiLocal = document.createRange();
      let indexMultiLocal =  SelectionToSaveintoList(startNode, 
        endNode, 
        startIndex, 
        endIndex, range);
      for(var i = 0; i<_nodes.length; i++)
        {
          let rangeLocal = document.createRange();
          let spanHighlightLocal = document.createElement('span');
          spanHighlightLocal.className = actionId===selectionmodifstate.comment ? 'Comment' : 'Highlight';
          if(i===0)
            {
              if( actionId===selectionmodifstate.comment)
                spanHighlightLocal.className += ' showcommentpin';
              rangeLocal.setStart(startNode, startIndex);
              rangeLocal.setEnd(startNode, startNode.nodeValue.length);
            }
          else if(i===_nodes.length-1)
            {
              rangeLocal.setStart(endNode, 0);
              rangeLocal.setEnd(endNode, endIndex);
            }
          else
            {
              if(_nodes[i].nodeType===document.TEXT_NODE)
              {
                rangeLocal.setStart(_nodes[i], 0);
                rangeLocal.setEnd(_nodes[i], _nodes[i].nodeValue.length);
              }
              else if(_nodes[i].nodeType===document.ELEMENT_NODE)
              {

                _nodes[i].parentNode.insertBefore(spanHighlightLocal, _nodes[i]);
                spanHighlightLocal.appendChild(_nodes[i]);
                for(var childMulti=spanHighlight.firstChild; childMulti!==null; childMulti=childMulti.nextSibling) {
                  newRangeObjectMultiLocal.selectNode(childMulti);
                }  

                continue;
              }
            }
            rangeLocal.surroundContents(spanHighlightLocal);
            if(i===0)
              {
                newRangeObjectMultiLocal.setStart(spanHighlightLocal.firstChild, 0);
              }
            if(i===_nodes.length-1)
              {
                newRangeObjectMultiLocal.setEnd(spanHighlightLocal.firstChild, spanHighlightLocal.firstChild.nodeValue.length);
              }
              spanHighlightLocal.setAttribute(actionId===selectionmodifstate.comment ? 'commentreference' : 'highlightreference', indexMultiLocal);      
       }
       if(actionId===selectionmodifstate.comment)
        {
          bCommentsChanged.current = true;
          commentsToBeSavedtoDB.current.set(indexMultiLocal.toString() , {range: newRangeObjectMultiLocal, comment: ""});
          setShowCommentBox({rangeofselection: newRangeObjectMultiLocal,  CommentBoxShow: true, reference: indexMultiLocal.toString(), comment:''});
        }
      else
        {
          bHighlightsChanged.current = true;
          highlightsToBeSavedtoDB.current.set(indexMultiLocal.toString() , newRangeObjectMultiLocal);
        }
    window.getSelection().removeAllRanges();
  }
  else if(actionId===selectionmodifstate.removehighlight ||  actionId===selectionmodifstate.removecomment)
    {
      // Remove Highlight
      // Nextstep: store and retreive new range objects directly with key value as reference.
      const reference = actionId===selectionmodifstate.removehighlight ? type.highlightreference : type.commentreference;
      if(reference===null)
        return;
      const rangeTobeDeleted = actionId===selectionmodifstate.removehighlight ? highlightsToBeSavedtoDB.current.get(reference) : commentsToBeSavedtoDB.current.get(reference).range;
      let iterator = document.createNodeIterator(
        rangeTobeDeleted.commonAncestorContainer,
        NodeFilter.SHOW_ALL, // pre-filter
        {
            // custom filter
            acceptNode: function (node) {
                return rangeTobeDeleted.intersectsNode(node) && node.nodeValue!= null && node.nodeValue.trim()!=='' ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
            }
        });
        let nodes = [];
      while (iterator.nextNode()) {
          nodes.push(iterator.referenceNode);
      }
      for(let ii = 0; ii<nodes.length; ii++)
        {
          // Span Highlight
          let parent = nodes[ii].parentElement;
          // SPan with ref.
          let parent_id = parent.parentElement.getAttribute('id');
          parent.parentElement.insertBefore(nodes[ii], parent);
          parent.parentElement.removeChild(parent);
          document.getElementById(parent_id).normalize();
        }

        if(actionId===selectionmodifstate.removecomment)
          {
            bCommentsChanged.current = true;
            commentsToBeSavedtoDB.current.delete(reference);
          }
        else
          {
            bHighlightsChanged.current = true;
            highlightsToBeSavedtoDB.current.delete(reference);
          }
    }
    else if(actionId===selectionmodifstate.addtorevisionnote)
    {
      const selectionText = window.getSelection().toString();
      if (!selectionText) {DoneWithContextMenu(); return;}
          setContentSBTabState(2);
          setaddtoNotesText(selectionText);

    }
    DoneWithContextMenu();


}

useEffect(() => {
  if (ContentSBTabState === 2 && addtoNotesText!='' && editorRef.current) {
    const editor = editorRef.current;

    // Insert at the end with a new line
     setValue(prev => prev + `<p>${addtoNotesText}</p>`);


       bRevisionNotesChanged.current = true;
    setaddtoNotesText('');

  }
}, [ContentSBTabState, addtoNotesText]);

function OnRevisionScheduleEventHandler(NextRevisionDate, offset, revert)
{
  if(revert===true)
    bRevisionScheduleChanged.current = false;
  else
    bRevisionScheduleChanged.current = true;
  setrevisionSchedule(prev => {return {...prev,
    NextRevisionDate: NextRevisionDate,
    Offset: offset
  }});
}
function SafariPreventDefault(event)
{
  event.stopPropagation();
  event.preventDefault();
  return false;
}
  //todo:: mutation observer JS for undo/redo.
  //todo:: on mouseleeave is at error in case of at the margins.
  function DisplayActionMenu(event)
    {
      const targetElement = event.target.closest('.SubscriptionWarning');
      if(targetElement)
        return false;
      event.stopPropagation();
      event.preventDefault();

    var selection =  window.getSelection();
    const isSelectionInContentPage = selection.anchorNode && selection.anchorNode.parentElement && selection.anchorNode.parentElement.closest('.ContentPage');; 
    if(!isSelectionInContentPage) return;
    var clickX = null;
    var clickY = null;
    var contentContextInSelection = { visible: true, type:{ highlightstate:0, highlightreference:null, commentstate:0, commentreference:null } };
    var selstring = selection.toString().trim();
    if(selstring!=="")
    {
    event = event || window.event;
    var src = event.target || event.srcElement;
    // selection with in a highlight or selection
    if(src.hasAttribute("highlightreference") || src.hasAttribute("commentreference"))
      {
        contentContextInSelection = {
          ...contentContextInSelection,
          visible: true,
          type:{
            highlightstate:-1,
            highlightreference:null,
            commentstate: -1,
            commentreference: null
          }
        }
      }
    var clientRect = selection.getRangeAt(0).getBoundingClientRect();
    clickX = clientRect.x  +(clientRect.width/2);
    clickY = clientRect.y  + (clientRect.height)+16;
    }
  else{
    if (event.touches && event.touches[0]) 
    {
        clickX = event.touches[0].clientX;
        clickY = event.touches[0].clientY+16;
    } 
    else if (event.changedTouches && event.changedTouches[0]) 
    {
      clickX = event.changedTouches[0].clientX;
      clickY = event.changedTouches[0].clientY+16;
    }
    else if (event.originalEvent && event.originalEvent.changedTouches[0]) 
    {
        clickX = event.originalEvent.changedTouches[0].clientX;
        clickY = event.originalEvent.changedTouches[0].clientY+16;
    } 
    else if (event.clientX && event.clientY) 
    {
      clickX = event.clientX;
      clickY = event.clientY+16;
    }
  }
  if(clickX!=null && clickY!= null)
    {
      contentMenuSection.current.style.left = clickX + 'px';
      contentMenuSection.current.style.top = clickY+'px';
    }
      if(selstring==='')
        {
          event = event || window.event;
          var src = event.target || event.srcElement;
          var contentContextMenuState = {visible:false, type: {highlightstate: 0, highlightreference: null, commentstate:0, commentreference: null}};
          if(!src.hasAttribute("highlightreference") && !src.hasAttribute("commentreference"))
            {
            setContentContextMenu(contentContextMenuState);
            // Any other click then close comment.
            setShowCommentBox(null);
            return false;
            }
          if(src.hasAttribute("highlightreference"))
            {
              contentContextMenuState = {
                ...contentContextMenu,
                visible: true,
                type:{
                  highlightstate:selectionmodifstate.highlight,
                  highlightreference:src.getAttribute("highlightreference"),
                  commentstate: -1,
                  commentreference: null
                }
              };
            }
          else
            {
              // if comment is clicked upon then show comment with edit and delete option.
              var reference = src.getAttribute("commentreference");
              setShowCommentBox({rangeofselection: commentsToBeSavedtoDB.current.get(reference).range,  
                                  CommentBoxShow: true, 
                                  reference: src.getAttribute("commentreference"), 
                                  comment: commentsToBeSavedtoDB.current.get(reference).comment});
              }
          setContentContextMenu(contentContextMenuState);
          return false;
        }
     
      // check if the selection is purely to be highlight removed.
    setContentContextMenu(contentContextInSelection);
    return false;
    }

    

  const joditConfig = useMemo(() => ({
  height: '100%',
  allowResizeY: false,
  allowResizeX: false,
  autofocus: false,
  saveSelectionOnBlur: false,
  placeholder: "Personal Notes",
  showPoweredBy: false,
   toolbarButtonSize: "small",
  toolbarAdaptive: false,
  observer: { resize: false },
  showCharsCounter: false,
  askBeforePasteHTML: false,
  askBeforePasteFromWord: false,
  defaultActionOnPaste: "insert_clear_html",
  showAbout: false,
  grouping: false,
   spellcheck: true,       // enables browser spellcheck
    iframe: false,
    iframeMode: false,
  showSpellcheckButton: false,
  speechRecognize: {
    permanent: false
},
  buttons: [
    // --- Formatting ---
    'bold', 'italic', 'underline', 'strikethrough',
    , 'eraser',     // equivalent of 'clean'
    'speechRecognize',
    

    // --- Block / Paragraph ---
    ,  {
    name: "paragraph",
    list: {
      p: "Normal",
      h1: "Heading 1",
      h2: "Heading 2"
    }
  },
    // --- Lists ---
    , 'ul', 'ol',

    // --- Alignment ---
    , 'align',

    // --- Colors ---
    , 'brush',  // includes color + background picker

    // --- Font Size + Font Family ---
    , 'fontsize',
    , 'font',

    // --- Media ---
    , 'link', 'image',

    // --- Table ---
    , 'table'
  ],
   allowBlockElements: {
    p: true,
    h1: true,
    h2: true,
  },
  removeButtons: ["paragraph"],
  image: {
    tabs: ["upload"], 
  },
   uploader: {
    insertImageAsBase64URI: true,  
  },

  disableBlockElements: [
    "h3", "h4", "h5", "h6",
    "pre", "address", "blockquote"
  ],
}), []);
  useEffect(() => {
    if (imageSrc && panZoomRef.current) {
      panZoomRef.current.fittedScale(); // Adjusts the image to fit the screen
    }
  }, [imageSrc]);

  useEffect(() => {
    const activeEl = menulistliRefs.current[activeIndexHeading];
    if (activeEl) {
      activeEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, [activeIndexHeading]);

  return ( isReady ? 
    <div>
      <NoPrintPage />
      {imageSrc && (<div className="imageViewer"><button className="closeImageViewerbtn" onClick={closeImageViewer}>X</button> <PanZoom ref={panZoomRef} image={imageSrc} /></div>)}
      {screenOrientationwarning === true && <div className="UseLandscapeAdvice">Using landscape orientation is better!!</div>}
      <div className="CPSideBar NoSelection">
        <div className={"CPSideBarWithButton top-[60px] md:top-[1%]  h-[calc(100vh-70px)] md:h-[calc(100vh-2%)] " + ( openMenu ? " CPSidebaractive" : " CPSidebarinactive")}>
          <div title="Navigation/Notes" className="ContentSBbtn" onClick={()=>{setOpenMenu(!openMenu); document.documentElement.style.marginRight = !openMenu && screenOrientation==="landscape" ? "25%" : "0%";}}>
            <i className={ openMenu ? "arrowright" : "arrowleft"}></i>
          </div>
        <div className="ContentSBTab">
          <div className="ContentSBTabButtons">
          { menulist.length>0 && <button className={ContentSBTabState===1 ? "ContentSBTabBtn ContentSBTabBtnActive" : "ContentSBTabBtn"} autoFocus onClick={() => {setContentSBTabState(1)}}>Navigation</button>}
          <button className={ContentSBTabState===2 ? "ContentSBTabBtn ContentSBTabBtnActive" : "ContentSBTabBtn"} onClick={() => setContentSBTabState(2)}>Craft Notes</button>
          </div>
          <div className="separatorafter"></div>
            <div className = 'ContentSBTBContentMaster'>
            {ContentSBTabState===1 && <div className='ContentSBTBContent'><nav className="ContentPageSidebar">
              {menulist.length &&
              menulist.map((heading, index) => {
                const text = heading.innerText.trim();
                if (text.length <= 1) return null;
            
                const baseClass =
                  heading.nodeName === 'H2' || heading.className === 'CivilsCodeHeading2Char'
                    ? 'subheading'
                    : heading.nodeName === 'H3' || heading.className === 'CivilsCodeHeading3Char'
                    ? 'subsubheading'
                    : 'CPSidebarMenuItem bigheading';
            
                const isActive = index === activeIndexHeading;
            
                return (
                  <li
                    key={index}
                    ref={(el) => (menulistliRefs.current[index] = el)}
                    className={`${baseClass} ${isActive ? 'active-li' : ''}`}
                    onClick={() => onCPMenuItem(index)}
                  >
                    {text}
                  </li>
                );
              })}     
            </nav></div>}
            {ContentSBTabState===2 && <div className={fullScreenChecked===false ? 'SecondCBTab' : 'fullScreenTab top-[40px] md:left-[80px] md:top-[0px]'}>
            <div className={fullScreenChecked===false ? 'FullScreenRN' : 'FullScreenRNTab'}>
                  <label className='FullScreenRNL'>Full Screen:</label>
                  <input type="checkbox" className='ToggleFullScreen' onChange={() => {setFullScreenChecked(!fullScreenChecked)}}/>
               </div>
               <div className={'ContentSBTBContentRE'}>
                    <JoditEditor
                        ref={editorRef}
                        value={value}
                        config={joditConfig}
                        onBlur={(newContent) => {
                          bRevisionNotesChanged.current = true;
                          setValue(newContent);
                        }}
                      />
               </div >
            </div>
            }
            </div>
        </div>
      </div>
      </div>
      <div  className="ContentPageWithContext" >
        <div className= 'CM' ref={contentMenuSection} onMouseLeave={()=>    {setContentContextMenu({...contentContextMenu, visible: false}); ; setShowCommentBox(null);}}>
         {contentContextMenu.visible===true && <ContentContextMenu type={contentContextMenu.type} PerformAction={PerformAction}/>}
        </div>
        {showCommentBox && showCommentBox.CommentBoxShow===true && <CommentBox key={showCommentBox.reference} rangeofSelection={showCommentBox.rangeofselection} reference={showCommentBox.reference} OnDeleteComment={commentBoxOnDeleteComment} onChangeComment={commentBoxOnChangeComment} prevcomment={showCommentBox.comment}/>}
       
        <div key="ContentHTML" className="ContentPage" onMouseUp ={DisplayActionMenu} onTouchEnd={DisplayActionMenu} dangerouslySetInnerHTML={{__html: contentBody}}>
        </div>
        {isPartial &&  <Subscribe msg="Subscribe To Unlock Full Content" /> }

        
        {menulist.length>0 && <AdditionalTabs tabIndex={-1} subject={subject} tK={tK} topic={topic}  />}

        <RevisionSchedulerButtonsAndTextBox  OnRevisionScheduleEvent={OnRevisionScheduleEventHandler} revisionSchedule={revisionSchedule}/>
      </div>

    </div> : <Spinner wholepage={true}/>

  )
}
// type.state 1 -> highlighted //current  state
// type.state 2 -> underlined //current state
// type.state 4 -> commented // current state
// action 1 -> highlight
// action 2 -> underline
// action 3 -> comment
// action 4 -> un highlight
// action 5 -> un underline
// action 6 -> un comment
/**
 * <div className="CMItem" onClick={() => {PerformAction(type.state&selectionmodifstate.underlined ? 5 : 2, type);}}>
  <img className='CMItemImage' src={process.env.PUBLIC_URL + '/underline.svg'}></img>
  {type.state&selectionmodifstate.underlined ? 'Erase Underline' : 'Underline'}</div>
 */
function ContentContextMenu({type, PerformAction})
{
return ((type.highlightstate!==-1 || type.commentstate!==-1) && <div className="contextMenu NoSelection flex flex-col md:flex-row">
{type.highlightstate!==-1 &&  <div className="CMItem" onTouchEnd = {(event) => { event.stopPropagation(); event.preventDefault(); PerformAction(type.highlightstate&selectionmodifstate.highlight ? selectionmodifstate.removehighlight : selectionmodifstate.highlight, type);}} onClick={(event) => {event.stopPropagation(); event.preventDefault(); PerformAction(type.highlightstate&selectionmodifstate.highlight ? selectionmodifstate.removehighlight : selectionmodifstate.highlight, type);}} >
 <div className='hidden md:block'>
  <HighlightSvg />
  </div>
  <div className="HighlightOptionText">
  {type.highlightstate&selectionmodifstate.highlight ? 'Erase Highlight' : 'Highlight'}
  </div>
</div>}
{type.commentstate!==-1 && <div className="CMItem" onTouchEnd = {(event) => { event.stopPropagation(); event.preventDefault(); PerformAction(type.commentstate&selectionmodifstate.comment ? selectionmodifstate.removecomment : selectionmodifstate.comment, type);}} onClick={(event) => {event.stopPropagation(); event.preventDefault(); PerformAction(type.commentstate&selectionmodifstate.comment ? selectionmodifstate.removecomment : selectionmodifstate.comment, type);}} >
<div className='hidden md:block'>
<CommentSvg />
</div>
  <div className="CommentOptionText">
  {type.commentstate&selectionmodifstate.comment ? 'Edit Comment' : 'Comment'}
  </div>
</div>}
{
  (type.highlightstate!==-1 && type.commentstate!==-1) && <div className="CMItem hidden md:block" onTouchEnd = {(event) => { event.stopPropagation(); event.preventDefault(); PerformAction(selectionmodifstate.addtorevisionnote, type);}} onClick={(event) => {event.stopPropagation(); event.preventDefault(); PerformAction(selectionmodifstate.addtorevisionnote, type);}} >
  <div>
  <AddToNotesSvg  />
  </div>
    <div className="AddToRevisionOptionText">
    {'Add To Notes'}
    </div>
  </div>}
</div>)
}


